goog.provide("shadow.js.shim.module$date_fns$lastDayOfMonth$default");
shadow.js.shim.module$date_fns$lastDayOfMonth$default = shadow.js.require(128, {})["default"];
